import { columnHelper } from './helper';

export const stackName = columnHelper.accessor('StackName', {
  header: 'Stack',
  id: 'stackName',
});
